import type { GeneratorType } from '../types/game-types';
import type { StatsSnapshot } from './gameplay-snapshot';
import { updateWarriorStats } from './warrior.stats';
import { updateWizardStats } from './wizard.stats';
import { updateElfStats } from './elf.stats';
import { updateGarrisonStats } from './garrison.stats';
import { updateCouncilStats } from './council.stats';
import { updateOutpostStats } from './outpost.stats';
import { updateCollegeStats } from './college.stats';
import { updateGuildStats } from './guild.stats';
import { updateTroupeStats } from './troupe.stats';
import { updateSeminaryStats } from './seminary.stats';
import { updateAcademyStats } from './academy.stats';
import { updateThiefStats } from './thief.stats';
import { updateBardStats } from './bard.stats';
import { updateClericStats } from './cleric.stats';
import { updateTotalStats } from './total.stats';
import { updateTheaterStats } from './theater.stats';
import { updateNexusStats } from './nexus.stats';
import { updateCongressStats } from './congress.stats';
import { updateForestStats } from './forest.stats';
import { updateClickStats } from './click.stats';
import { updateCatapultStats } from './catapult.stats';

/** Re-export single seam for stats/tick code when upgrades move to Zustand. */
export type { StatsSnapshot } from './gameplay-snapshot';
export { buildStatsSnapshot } from './gameplay-snapshot';

export const updateStats = (state: StatsSnapshot) => {
  updateClickStats(state);

  updateWarriorStats(state);
  updateWizardStats(state);
  updateElfStats(state);
  updateThiefStats(state);
  updateBardStats(state);
  updateClericStats(state);

  updateGarrisonStats(state);
  updateAcademyStats(state);
  updateOutpostStats(state);
  updateGuildStats(state);
  updateTroupeStats(state);
  updateSeminaryStats(state);

  updateCouncilStats(state);
  updateNexusStats(state);
  updateForestStats(state);
  updateCongressStats(state);
  updateTheaterStats(state);
  updateCollegeStats(state);

  updateCatapultStats(state);

  updateTotalStats(state);
};

export type UnitStats = {
  mainIndividualGenerationStat?: number;
  damagePerClick?: number;
  damagePerTick?: number;
  criticalChance?: number;
  criticalDamage?: number;
  goldGeneration?: number;
  inspirationGeneration?: number;
  unitsGeneration?: number;
  buildingsGeneration?: number;
};

export const unitStats: Record<GeneratorType | 'click' | 'total', UnitStats> = {
  total: {},
  click: {},
  warrior: {},
  wizard: {},
  elf: {},
  thief: {},
  bard: {},
  cleric: {},
  garrison: {},
  academy: {},
  outpost: {},
  guild: {},
  troupe: {},
  seminary: {},
  council: {},
  nexus: {},
  forest: {},
  congress: {},
  theater: {},
  college: {},
  farmer: {},
  lumberjack: {},
  miner: {},
  catapult: {},
};
